import { ColDef } from 'ag-grid-community';

export const DocumentIdCol = {
  colId: 'documentId',
  field: 'documentId',
  hide: true
} as ColDef;
